module.exports = __webpack_public_path__ + "static/media/star_1AC4AD.ab4d6628.svg";